/**
 * Membersihkan string barcode dari karakter tanda petik (single quote, double quote,
 * backtick, dan variasi curly/smart quotes) serta spasi di awal dan akhir,
 * menghasilkan nilai barcode yang murni dan siap diproses sistem.
 *
 * @param {string | null | undefined} raw - String barcode mentah dari scanner atau input teks.
 * @returns {string} String barcode yang telah dibersihkan tanpa tanda petik dan spasi di ujungnya.
 * @sideEffects Tidak ada efek samping (fungsi murni / pure function).
 */
export function cleanBarcode(raw) {
  if (!raw) return '';
  if (typeof raw !== 'string') {
    raw = String(raw);
  }
  // Menghapus semua variasi tanda petik: single quote, double quote, backtick, smart/curly quotes
  return raw.replace(/['"`‘’“”„‟′″‵‶´]/g, '').trim();
}

export default cleanBarcode;
